import { render, staticRenderFns } from "./dialogInfoNoGaranzia.vue?vue&type=template&id=0aeb6f42&scoped=true"
import script from "./dialogInfoNoGaranzia.vue?vue&type=script&lang=js"
export * from "./dialogInfoNoGaranzia.vue?vue&type=script&lang=js"
import style0 from "./dialogInfoNoGaranzia.vue?vue&type=style&index=0&id=0aeb6f42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aeb6f42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDialog})
